import { render, staticRenderFns } from "./resetPasswordForm.vue?vue&type=template&id=63dfdc35"
import script from "./resetPasswordForm.vue?vue&type=script&lang=js"
export * from "./resetPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports